import React from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * A modal dialog that will pop up with a message passed in from the parent component.
 *
 * @param show - Boolean state indicating if the modal should be displayed
 * @param handleClose - Function to call when the user clicks to close the modal
 * @param message - The message to display in the dialog.
 * @param title - Optional title for the modal dialog
 * @returns {Element} - A modal dialog to display the message
 */
const MessageOverlay = ({ show, handleClose, message, title = null }) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} size="md" centered backdrop="static" id="claimStatusWindow" keyboard={false}>
        <Modal.Header>
          <span className="close" onClick={handleClose}>&times;</span>
          <Modal.Title className="message-overlay-modal-header">
            {title && (<span>{title}</span>)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="message-overlay-modal-body">
            {message && (<p className="message-overlay-body">{message}</p>)}
          </div>
        </Modal.Body>
        <Modal.Footer>
           <Button className="btn btn-primary login-modal-button sigmar-center-element" onClick={handleClose}>
           Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MessageOverlay;
